import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

const PORT = import.meta.env.VITE_COOK_PORT;
const URL = import.meta.env.VITE_API_COOK_URL;

interface CookMenuApprovals {
  cookName: any;
  foodMenuName: any;
  id: number | null;
  approvalStatus: any;
}

interface CookMenuApproval {
  data: CookMenuApprovals[];
  getByIdCookData: any;
  loading: boolean;
  error: string | null;
}

interface getByIdCookData {
  getByIdCookData: null;
}
interface ApiResponse {
  data: CookMenuApprovals[];
}

export const fetchCookMenuApprovals = createAsyncThunk<
  CookMenuApprovals[],
  void,
  { rejectValue: string }
>('fetchCookMenuApprovals/Approval', async (_, { rejectWithValue }) => {
  try {
    const response = await apiService.get<ApiResponse>(
      '/get_all_cook_created_food_menu_workflow',
      PORT,
      URL,
    );
    return response.data;
  } catch (error) {
    return rejectWithValue('Failed to fetch food approvals');
  }
});

export const getByIdCookMenuApprovals = createAsyncThunk<any, { id: any }, { rejectValue: string }>(
  'Approval/getByIdCookMenuApprovals',
  async ({ id }, { rejectWithValue }) => {
    try {
      const config = { params: { id } };
      const response = await apiService.get<getByIdCookData>(
        `get_by_id_cook_created_food_menu_workflow`,
        PORT,
        URL,
        config,
      );
      console.log('responce', response);

      return response;
    } catch (error: any) {
      return rejectWithValue(error?.message || 'Failed to fetch food menu ingredients');
    }
  },
);

export const updateCookMenuApprovals = createAsyncThunk<
  CookMenuApprovals[],
  { payload: any },
  { rejectValue: string }
>('updateCookMenuApprovals', async ({ payload }, { rejectWithValue }) => {
  try {
    const response = await apiService.put<ApiResponse>(
      '/update_cook_created_food_menu_workflow',
      payload,
      PORT,
      URL,
    );
    return response.data;
  } catch (error) {
    return rejectWithValue('Failed to update Menu approval');
  }
});

const initialState: CookMenuApproval = {
  data: [],
  getByIdCookData: null,
  loading: false,
  error: null,
};

const cookMenuApprovalsSlice = createSlice({
  name: 'CookMenuApprovals',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCookMenuApprovals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchCookMenuApprovals.fulfilled,
        (state, action: PayloadAction<CookMenuApprovals[]>) => {
          state.loading = false;
          state.data = action.payload;
        },
      )
      .addCase(fetchCookMenuApprovals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Unknown error';
      })

      .addCase(getByIdCookMenuApprovals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getByIdCookMenuApprovals.fulfilled,
        (state, action: PayloadAction<getByIdCookData[]>) => {
          state.loading = false;
          state.getByIdCookData = action.payload;
        },
      )
      .addCase(getByIdCookMenuApprovals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Unknown error';
      })

      .addCase(updateCookMenuApprovals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCookMenuApprovals.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data.push(action.payload);
      })
      .addCase(updateCookMenuApprovals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Unknown error';
      });
  },
});

export default cookMenuApprovalsSlice.reducer;
